module.exports = __webpack_public_path__ + "media/images/emoticons/sun-6978ac971720954e883532536fa82d7f.gif";